var _defineProperty = require("/mnt/Data/.My_Projects/githubProjects/gpu.rocks/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _require = require('../../cli/colors'),
    YELLOW_UNDER = _require.YELLOW_UNDER,
    RED_FLASH = _require.RED_FLASH,
    NC = _require.NC,
    BenchmarkOut = require('./benchmark-out'),
    getDefaultOptions = require('./get-default-options'),
    run = require('../run'),
    _require2 = require('../../cli/format'),
    br = _require2.br;

var defaultOptions = {
  common_options: {
    // options common to all but can be overridden in range or in full_options, preference given to range
    cpu_benchmark: false
  },
  range: {
    // only one of this and full_options works
    option_name: 'matrix_size',
    interval: [128, 1024],
    step: 100 //(default 10) one of step or common_ratio can be used, preference given to step
    // common_ratio: 2 (G.P.: 128, 256, 512, 1024)

  },
  full_options: [{// array of options objects for each benchmark(only one of this and range works, preference given to range)
  }]
};
/**
 * @method multipleBenchmark
 * @description runs multiple GPU.js benchmarks each with different options
 * @param {"Object"} options array of optional options objects
 * @returns {"Object"}
 */

var multipleBenchmark = function multipleBenchmark() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOptions;
  var out = new BenchmarkOut();
  var commonBenchmarkOptions = getDefaultOptions(options.common_options || defaultOptions.common_options);
  var benchmarkOptionsArr = [];

  if (options.range) {
    var interval = options.range.interval,
        option_name = options.range.option_name;

    if (options.range.step) {
      var step = options.range.step;

      for (var i = interval[0]; i <= interval[1]; i += step) {
        benchmarkOptionsArr.push(_objectSpread({}, commonBenchmarkOptions));
        benchmarkOptionsArr[benchmarkOptionsArr.length - 1][option_name] = i;
      }
    } else if (options.range.common_ratio) {
      var common_ratio = options.range.common_ratio;

      for (var _i = interval[0]; _i <= interval[1]; _i *= common_ratio) {
        benchmarkOptionsArr.push(_objectSpread({}, commonBenchmarkOptions));
        benchmarkOptionsArr[benchmarkOptionsArr.length - 1][option_name] = Math.min(_i, interval[1]);
      }
    } else {
      var _step = 10;

      for (var _i2 = interval[0]; _i2 <= interval[1]; _i2 += _step) {
        benchmarkOptionsArr.push(_objectSpread({}, commonBenchmarkOptions));
        benchmarkOptionsArr[benchmarkOptionsArr.length - 1][option_name] = _i2;
      }
    }
  } else if (options.full_options) {
    options.full_options.forEach(function (optionSet) {
      benchmarkOptionsArr.push(_objectSpread(_objectSpread({}, commonBenchmarkOptions), optionSet));
    });
  }

  benchmarkOptionsArr.forEach(function (benchmarkOption, i) {
    console.log("Config ".concat(YELLOW_UNDER, "#").concat(i).concat(NC, ":"));
    console.log("MATRIX_SIZE: ".concat(YELLOW_UNDER).concat(benchmarkOption.matrix_size).concat(NC));
    console.log("NUM_ITERATIONS: ".concat(YELLOW_UNDER).concat(benchmarkOption.num_iterations).concat(NC));
    console.log("CPU_BENCHMARK: ".concat(YELLOW_UNDER).concat(benchmarkOption.cpu_benchmark).concat(NC));
    br();
    out.addData(run(benchmarkOption));
    br();
    br();
  });
  if (benchmarkOptionsArr.length === 0) console.log("".concat(RED_FLASH, "The Options are Invalid").concat(NC));
  return out;
};

module.exports = multipleBenchmark;